import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import urlify from 'utils/urlify'

const Select = ({
  options,
  onChange,
  name,
  styles,
  label,
  selectId
}) => (
  <div className={styles.wrapper}>
    {label &&
      // TODO: Improve A11Y and re-enable ESLint
      // eslint-disable-next-line jsx-a11y/label-has-for
      <label
        htmlFor={urlify(name)}
        className={styles.label}
      >
        {label}
      </label>
    }
    { /* TODO: Improve A11Y and re-enable ESLint */ }
    { /* eslint-disable jsx-a11y/no-onchange */ }
    <select
      id={label ? urlify(name) : selectId}
      value={(options.find(({ selected }) => selected) || {}).value}
      onChange={onChange}
      className={classnames('no-selectize', { [styles.select]: styles.select })}
    >
      { /* eslint-enable */ }
      {options.map(({ label: text, value }) => (
        <option
          key={value}
          value={value}
        >
          {text}
        </option>
      ))}
    </select>
  </div>
)

const optionShape = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.any
})

Select.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.arrayOf(optionShape).isRequired,
  styles: PropTypes.shape({
    wrapper: PropTypes.string,
    label: PropTypes.string,
    select: PropTypes.string
  }),
  onChange: PropTypes.func,
  selectId: PropTypes.string
}

Select.defaultProps = {
  name: null,
  styles: {},
  label: null,
  selectId: null,
  onChange: () => {}
}

export default Select
